import { useEffect } from 'react';
import { useWishlistSelectedItemsContext } from 'fdr/components/candidate/fdr-wishlist/fdr-wishlist-selected-items-context';
import { isFdrWishlistProductHotel } from 'fdr/components/candidate/fdr-wishlist/fdr-wishlist.types';
import { FdrProductPin } from 'fdr/components/local/fdr-srl-map/fdr-srl-map.types';
import { FdrWishlistItemFragment } from 'fdr/schemas/fragment/wishlist/fdr-wishlist.generated';

interface IWishlistMapItemsConfig {
  onCompleted?: (wishlistItems: FdrProductPin[]) => void;
}

export default function useWishlistMapItems(config: IWishlistMapItemsConfig): {
  loading: boolean;
  mapItems: FdrProductPin[];
} {
  const { onCompleted } = config;

  const { items, itemsLoading: loading } = useWishlistSelectedItemsContext();

  useEffect(() => {
    if (items && !loading && onCompleted) {
      onCompleted(getWishlistMapItems(items));
    }
  }, [items, loading, onCompleted]);

  const mapItems = getWishlistMapItems(items);

  return {
    loading,
    mapItems,
  };
}

const getWishlistMapItems = (
  items: FdrWishlistItemFragment[]
): FdrProductPin[] => {
  return (
    items
      ?.map(({ product, trackedOffer: offer }) => {
        if (!isFdrWishlistProductHotel(product)) {
          return null;
        }
        const pricePerPerson = offer?.latest
          ? offer.latest.pricePerPerson
          : offer.original.pricePerPerson;
        return {
          pricePerPerson,
          product,
        };
      })
      .filter(i => i) || []
  );
};
